const cardSelector = '[data-veroni-card]';

function rememberOriginal(card) {
  const primary = card.querySelector('[data-veroni-card-primary]');
  const secondary = card.querySelector('[data-veroni-card-secondary]');
  if (primary && !card.dataset.veroniOrigSrc) {
    card.dataset.veroniOrigSrc = primary.currentSrc || primary.src || '';
    card.dataset.veroniOrigSrcset = primary.getAttribute('srcset') || '';
  }
  if (secondary && card.dataset.veroniOrigSecondary === undefined) {
    card.dataset.veroniOrigSecondary = secondary.getAttribute('src') || '';
  }
}

const GOLD_IMAGE_KEYS = { yellow: 'imageYellow', white: 'imageWhite', rose: 'imageRose' };

/**
 * The photo a dot shows. A stone dot shows that stone in the card's selected
 * gold, and a gold dot shows the stone the shopper pinned in that gold, when the
 * card carries that pair (data-image-<gold> on the stone dots); otherwise the
 * dot's own photo.
 */
function previewSource(card, button) {
  let pairSrc = '';
  if (button.hasAttribute('data-veroni-gem')) {
    const metal = card.querySelector('[data-veroni-metal].is-selected');
    const key = metal && GOLD_IMAGE_KEYS[metal.dataset.veroniMetal];
    pairSrc = (key && button.dataset[key]) || '';
  } else if (button.hasAttribute('data-veroni-metal') && card.dataset.veroniPinned) {
    const gem = card.querySelector('[data-veroni-gem].is-selected');
    const key = GOLD_IMAGE_KEYS[button.dataset.veroniMetal];
    pairSrc = (gem && key && gem.dataset[key]) || '';
  }
  if (pairSrc) return { src: pairSrc, srcset: '' };
  return { src: button.dataset.image, srcset: button.dataset.srcset || '' };
}

function setPrimary(primary, src, srcset) {
  primary.src = src;
  // A leftover srcset would win over the new src.
  if (srcset) primary.srcset = srcset;
  else primary.removeAttribute('srcset');
}

function applyCardPreview(card, button) {
  if (!card || !button) return;
  rememberOriginal(card);
  const primary = card.querySelector('[data-veroni-card-primary]');
  const secondary = card.querySelector('[data-veroni-card-secondary]');
  const links = card.querySelectorAll('[data-veroni-card-link]');
  const { src, srcset } = previewSource(card, button);
  const secondarySrc = button.dataset.imageSecondary;
  const href = button.dataset.href;

  if (primary && src) {
    setPrimary(primary, src, srcset);
    card.classList.add('is-previewing');
  }
  if (secondary) {
    if (secondarySrc) {
      secondary.src = secondarySrc;
      secondary.removeAttribute('hidden');
    } else {
      secondary.setAttribute('hidden', '');
    }
  }
  if (href) links.forEach((link) => link.setAttribute('href', href));
}

function restoreCardPreview(card) {
  if (!card) return;
  const primary = card.querySelector('[data-veroni-card-primary]');
  const secondary = card.querySelector('[data-veroni-card-secondary]');
  if (primary && card.dataset.veroniOrigSrc) {
    setPrimary(primary, card.dataset.veroniOrigSrc, card.dataset.veroniOrigSrcset);
  }
  if (secondary) {
    if (card.dataset.veroniOrigSecondary) {
      secondary.src = card.dataset.veroniOrigSecondary;
      secondary.removeAttribute('hidden');
    }
  }
  card.classList.remove('is-previewing');
}

function pinFromButton(card, button, groupSelector) {
  rememberOriginal(card);
  const primary = card.querySelector('[data-veroni-card-primary]');
  const { src, srcset } = previewSource(card, button);
  card.dataset.veroniPinned = '1';
  if (primary && src) {
    card.dataset.veroniOrigSrc = src;
    card.dataset.veroniOrigSrcset = srcset;
  }
  if (button.dataset.imageSecondary !== undefined) {
    card.dataset.veroniOrigSecondary = button.dataset.imageSecondary || '';
  }
  applyCardPreview(card, button);
  card.querySelectorAll(groupSelector).forEach((el) => {
    const selected = el === button;
    el.classList.toggle('is-selected', selected);
    el.setAttribute('aria-pressed', String(selected));
  });
}

document.addEventListener('click', (event) => {
  const metalButton = event.target.closest('[data-veroni-metal]');
  if (metalButton) {
    const card = metalButton.closest(cardSelector);
    if (!card) return;
    pinFromButton(card, metalButton, '[data-veroni-metal]');
    return;
  }

  const gemButton = event.target.closest('[data-veroni-gem]');
  if (gemButton) {
    const card = gemButton.closest(cardSelector);
    if (!card) return;
    pinFromButton(card, gemButton, '[data-veroni-gem]');
  }
});

document.addEventListener('pointerover', (event) => {
  const button = event.target.closest('[data-veroni-gem], [data-veroni-metal]');
  if (!button) return;
  const card = button.closest(cardSelector);
  if (!card) return;
  applyCardPreview(card, button);
});

document.addEventListener('pointerout', (event) => {
  const button = event.target.closest('[data-veroni-gem], [data-veroni-metal]');
  if (!button) return;
  if (button.contains(event.relatedTarget)) return;
  const card = button.closest(cardSelector);
  if (!card) return;
  restoreCardPreview(card);
});

if (document.querySelector('[data-veroni-pagination-region] [data-veroni-load-more]')) {
  const infinite = document.createElement('script');
  infinite.src = new URL('veroni-infinite-scroll.js', import.meta.url).href;
  infinite.defer = true;
  document.head.appendChild(infinite);
}
